import React from "react";
import ApexCharts from "react-apexcharts";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
// import ChartHeader from "../ChartHeader"; // Adjust the path as necessary

const DivisionVsStoreChart = ({ data, onStackClick }) => {
  // const options = {
  //   chart: {
  //     type: "bar",
  //     stacked: true,
  //     events: {
  //       dataPointSelection: (
  //         event,
  //         chartContext,
  //         { dataPointIndex, seriesIndex }
  //       ) => {
  //         onStackClick(dataPointIndex, seriesIndex);
  //       },
  //     },
  //   },
  //   xaxis: { categories: data.categories },
  //   yaxis: { title: { text: "Products" } },
  //   plotOptions: {
  //     bar: {
  //       horizontal: false,
  //     },
  //   },
  // };

  // return <ApexCharts options={options} series={data.series} type="bar" height={400} />;
  return (
    <Grid item xs={6}>
      <Paper elevation={3} sx={{ padding: "20px" }}>
        <ApexCharts
          options={{
            title: {
              text: "Division vs Store",
            },
            tooltip: {
              enabled: true,
              z: {
                title:
                  "Shows the product distribution by gender across stores.",
              },
            },
            chart: {
              type: "bar",
              height: 350,
              stacked: true, // Enable stacking
              events: {
                dataPointSelection: (event, chartContext, { dataPointIndex, seriesIndex }) => {
                  if (onStackClick) {
                    onStackClick(dataPointIndex, seriesIndex); // Pass store and division indices
                  }
                },
              },
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 6, // Add rounded corners
                borderRadiusApplication: "end", // Apply to the end
                borderRadiusWhenStacked: "last", // Apply rounding to the last stacked bar
                dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: "13px",
                      fontWeight: 900,
                    },
                  },
                },
              },
            },
            xaxis: {
              categories: data.categories, // Ensure categories are correctly passed
              labels: {
                style: {
                  fontSize: "12px",
                },
              },
            },
            yaxis: {
              title: {
                text: "Products",
              },
            },
            legend: {
              offsetY: 40,
            },
            fill: {
              opacity: 1,
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    offsetX: -10,
                    offsetY: 0,
                  },
                },
              },
            ],
          }}
          series={data.series} // Ensure series data is structured correctly
          type="bar"
          height={450}
        />
      </Paper>
    </Grid>
  );
};

export default DivisionVsStoreChart;
